import styled from 'styled-components'

const FileInfoStyle = styled.div`
  margin: 12px 0 0 16px;
  display: grid;
  font-size: 14px;
  grid-template-areas:
    'name name'
    'code variant'
    'version version';
  grid-row-gap: 12px;

  .header {
    font-size: 11px;
  }

  .name {
    grid-area: name;
  }

  .code {
    grid-area: code;
  }

  .version {
    grid-area: version;
  }

  .variant {
    grid-area: variant;
  }
`
export default FileInfoStyle
